import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import FloorPlanOverlay from './FloorPlanOverlay'
import ContextMenu from 'ContextMenu'
import showContextMenu from 'helpers/showContextMenu'
import { updateFloorPlanAction, destroyFloorPlanAction, scaleFloorPlanAction } from 'actions/floorPlanActions'
import { addMapComponentReferencesAction } from 'actions/mapActions'
import { messageAction } from 'actions/messageActions'
import { setCurrentMarkupAction } from 'actions/markupActions'

@connect(
  ({ currentEntity, ui: { drawingWall, drawingWire } }) => ({ currentEntity, drawing: drawingWall || drawingWire }),
  { updateFloorPlanAction, destroyFloorPlanAction, scaleFloorPlanAction,
    addMapComponentReferencesAction, messageAction, setCurrentMarkupAction })
class FloorPlan extends React.Component {
  componentDidMount() {
    const { remove, props: { id, map, locked, newlyAdded, scaleFloorPlanAction } } = this
    try {
      this.overlay = new FloorPlanOverlay(this.props)
    } catch (e) {
      console.log(e)
    }
    // if the floor plan is the current entity, continue through standard marker visibilty work.
    // if not, hide everything
    this.setOverlayLocked(this.isCurrent() ? locked : true)
    this.contextMenu = new ContextMenu(map, this.contextMenuOptions())
    this.addEventListeners()

    this.props.addMapComponentReferencesAction('floorPlans', id, { remove, overlay: this.overlay })
    if (newlyAdded) scaleFloorPlanAction(id)
  }

  addEventListeners = _ => {
    const { contextMenu, setToCurrentMarkup, props: { id, messageAction } } = this

    google.maps.event.addListener(this.overlay, 'location_changed', googleLocation => {
      const { nw, se } = googleLocation
      const location = {
        nw: { lat: nw.lat(), lng: nw.lng() },
        se: { lat: se.lat(), lng: se.lng() }
      }
      this.props.updateFloorPlanAction(id, { location })
    })

    this.overlay.addListener('contextmenu', showContextMenu(contextMenu))
    google.maps.event.addListener(contextMenu, 'menu_item_selected', this.eventHandler)
    this.overlay.addListener('mousedown', setToCurrentMarkup)
    this.overlay.addListener('mousedown', _ => this.props.locked && messageAction('generalError', 'This floorplan is locked. Right click to unlock.'))
  }

  setToCurrentMarkup = _ => {
    if (!this.props.drawing && !this.isCurrent() && !this.props.locked) {
      this.props.setCurrentMarkupAction(this.props.id, 'floorPlan')
    }
  }

  contextMenuOptions = _ => {
    const menuItems = this.props.mapContextMenuOptions.menuItems

    const menuItemBuilder = function() {
      const { locked, classes } = this.props
      return menuItems.concat([
        {
          className: classes.contextMenuItem,
          eventName: 'deleteFloorPlan',
          id: 'menu_item_delete_floor_plan',
          label: `${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={['far', 'trash-alt']} />)} Delete Floor Plan`
        },
        {
          className: classes.contextMenuItem,
          eventName: 'toggleFloorPlanLock',
          id: 'menu_item_toggle_floor_plan_lock',
          label: `${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={locked ? 'unlock' : 'lock'} />)} ${locked ? 'Unlock' : 'Lock'} Floor Plan`
        },
        {
          className: classes.contextMenuItem,
          eventName: 'scaleFloorPlan',
          id: 'menu_item_scale_floor_plan',
          label: `${ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon='expand-arrows-alt' />)} Scale Floor Plan`
        }
      ])
    }

    return {
      classNames: {
        menu: this.props.classes.contextMenu,
        menuSeparator: this.props.classes.contextMenuSeparator
      },
      menuItems: menuItemBuilder.bind(this)
    }
  }

  eventHandler = (latLng, eventName) => {
    const { props: { id, name, locked, destroyFloorPlanAction, mapContextMenuEventHandler, updateFloorPlanAction, scaleFloorPlanAction } } = this
    const mapContextMenuEvents = ['addCamHere', 'centerMapHere', 'zoomToAllDevices']
    if (mapContextMenuEvents.includes(eventName)) {
      mapContextMenuEventHandler(latLng, eventName)
    } else {
      switch (eventName) {
        case 'deleteFloorPlan':
          if (locked) {
            this.props.messageAction('generalError', 'Cannot delete locked floorplan. Right click to unlock.')
          } else if (window.confirm(`Are you sure you want to delete ${this.props.name || `Floor Plan ${this.props.id}`}?`)) {
            destroyFloorPlanAction(id)
          }
          break
        case 'toggleFloorPlanLock':
          updateFloorPlanAction(id, { locked: !locked })
          break
        case 'scaleFloorPlan':
          scaleFloorPlanAction(id)
          break
      }
    }
    this.contextMenu.hide()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.locked !== nextProps.locked) {
      this.setOverlayLocked(nextProps.locked)
    }

    if (this.willNotBeCurrent(nextProps) && this.isCurrent(nextProps)) {
      this.overlay.setMarkerVisible(false)
      this.overlay.setDraggable(false)
    }

    if (this.willBeCurrent(nextProps) && !nextProps.locked) {
      this.overlay.setMarkerVisible(true)
      this.overlay.setDraggable(true)
    }

    if (this.props.opacity !== nextProps.opacity) {
      this.overlay.updateOpacity(nextProps.opacity)
    }
  }

  setOverlayLocked = (locked) => {
    this.overlay.setMarkerVisible(!locked)
    this.overlay.setDraggable(!locked)
  }

  remove = _ => {
    const { scaler } = this.props
    scaler && scaler.setMap(null)
    this.overlay.setMap(null)
  }

  isCurrent = _ =>
    this.props.currentEntity.id === this.props.id &&
    this.props.currentEntity.type === 'floorPlan'

  willBeCurrent = props => {
    return (this.props.currentEntity.id !== props.currentEntity.id ||
      this.props.currentEntity.type !== props.currentEntity.type) &&
    props.currentEntity.id === this.props.id &&
    props.currentEntity.type === 'floorPlan'
  }

  willNotBeCurrent = props =>
    props.currentEntity.id !== this.props.id ||
    props.currentEntity.type !== 'floorPlan'

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}

export default injectSheet(style)(FloorPlan)



// WEBPACK FOOTER //
// ./src/components/FloorPlan/index.js